export default "<p>\r\n  noteviewer works!\r\n</p>\r\n";